import React, { useState } from 'react';

const NEWSLETTER_SIGNUP_URL = 'https://lp.constantcontactpages.com/su/nJEZT9L?__cf_chl_tk=ctbe1cbByMqU7_aMp1OdkrZjRix5KqRGTdT6iLfBou0-1772070444-1.0.1.1-o2cE7SuLR4MBPgKdy4GtfrCuSMowzaZ.P8NnBAXsX2A';

export default function SubscribeDialogBox() {
  const [isHovered, setIsHovered] = useState(false);
  const hover = isHovered ? 'hover' : '';

  return (
    <a
      className="subscribe"
      href={NEWSLETTER_SIGNUP_URL}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="subscribe-text">Subscribe for Newsletter Updates</div>
      <div className="subscribe-arrow-wrap"><span className={`material-icons-round subscribe-arrow ${hover}`}>east</span></div>
    </a>
  );
}
